import { CoreApi } from '../services/api';
import ProfileStore from './store';

const store = new ProfileStore({ api: new CoreApi() });
export default store;
